/*
  Omnify PDP enhancements for Tonochi
  1. Price next to the title follows the pack + purchase option chosen in Kaching
  2. Price per unit inside every Kaching pack card
  3. Sticky add-to-cart bar on mobile
  4. Smooth scroll for links to #tn-reviews and #tn-buy
*/
(() => {
  if (window.__tnPdp) return;
  window.__tnPdp = true;

  const moneyFormat = (window.themeVariables && window.themeVariables.settings.moneyFormat) || '${{amount}}';
  const fmt = (value) => moneyFormat
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toLocaleString('en-US'))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.toFixed(2).replace('.', ','))
    .replace(/\{\{\s*amount\s*\}\}/, value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  const toNumber = (text) => {
    if (!text) return NaN;
    const clean = String(text).replace(/[^0-9.,]/g, '');
    const normalised = /,\d{2}$/.test(clean) ? clean.replace(/\./g, '').replace(',', '.') : clean.replace(/,/g, '');
    return parseFloat(normalised);
  };
  const singular = (word) => {
    const w = word.toLowerCase();
    if (/(sh|ch|x|ss)es$/.test(w)) return w.slice(0, -2);
    if (w.endsWith('s')) return w.slice(0, -1);
    return w;
  };
  const parseTitle = (text) => {
    const m = String(text || '').match(/(\d+)\s*([A-Za-z]+)/);
    return m ? { count: parseInt(m[1], 10), unit: singular(m[2]) } : null;
  };
  const txt = (el) => (el ? el.textContent.trim() : '');

  let writing = false;
  let state = { price: null, compare: null, perUnit: null, unit: null };

  /* 2. Price per unit in each pack card */
  const updateBars = (root) => {
    root.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
      const info = parseTitle(txt(bar.querySelector('.kaching-bundles__bar-title')));
      const price = toNumber(txt(bar.querySelector('.kaching-bundles__bar-price')));
      const line = bar.querySelector('.kaching-bundles__bar-second-line') || bar.querySelector('.kaching-bundles__bar-content-left');
      if (!info || !line || !price) return;
      let el = line.querySelector('.tn-unit');
      if (info.count <= 1) { if (el) el.remove(); return; }
      const label = `${fmt(price / info.count)}/${info.unit}`;
      if (!el) { el = document.createElement('span'); el.className = 'tn-unit'; line.appendChild(el); }
      if (el.textContent !== label) el.textContent = label;
    });
  };

  /* 1. Price next to the title */
  const readSelection = (root) => {
    const card = root.querySelector('.kaching-subscriptions__card-wrapper.selected');
    const bar = root.querySelector('.kaching-bundles__bar--selected');
    let price = NaN; let compare = NaN;
    if (card) {
      price = toNumber(txt(card.querySelector('.kaching-subscriptions__card-price')));
      compare = toNumber(txt(card.querySelector('.kaching-subscriptions__original-price')));
    }
    if (!price && bar) {
      price = toNumber(txt(bar.querySelector('.kaching-bundles__bar-price')));
      compare = toNumber(txt(bar.querySelector('.kaching-bundles__bar-full-price')));
    }
    const info = bar ? parseTitle(txt(bar.querySelector('.kaching-bundles__bar-title'))) : null;
    return {
      price: price || null,
      compare: compare && compare > price ? compare : null,
      perUnit: info && info.count > 1 && price ? price / info.count : null,
      unit: info ? info.unit : null
    };
  };

  const updatePrice = (root) => {
    const list = root.querySelector('price-list.price-list--product');
    if (!list || !state.price) return;
    const sale = list.querySelector('sale-price');
    if (sale) {
      const label = fmt(state.price);
      const textNode = [...sale.childNodes].reverse().find((n) => n.nodeType === 3 && n.textContent.trim());
      if (textNode && textNode.textContent.trim() !== label) textNode.textContent = label;
    }
    let compare = list.querySelector('.tn-compare');
    if (state.compare) {
      if (!compare) { compare = document.createElement('span'); compare.className = 'tn-compare'; list.appendChild(compare); }
      if (compare.textContent !== fmt(state.compare)) compare.textContent = fmt(state.compare);
    } else if (compare) compare.remove();
    let unit = list.querySelector('.tn-price-unit');
    if (state.perUnit) {
      if (!unit) { unit = document.createElement('span'); unit.className = 'tn-price-unit'; list.appendChild(unit); }
      const unitLabel = `${fmt(state.perUnit)} per ${state.unit}`;
      if (unit.textContent !== unitLabel) unit.textContent = unitLabel;
    } else if (unit) unit.remove();
  };

  /* 3. Sticky add to cart (mobile) */
  let sticky;
  const buildSticky = (root) => {
    if (sticky || !root.querySelector('buy-buttons button[type="submit"]')) return;
    const title = txt(root.querySelector('.product-info__title')) || txt(root.querySelector('.product-info h1, .product-info h2, .product-info h3, .product-info h4'));
    sticky = document.createElement('div');
    sticky.className = 'tn-sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML = `
      <div class="tn-sticky-atc__info">
        <span class="tn-sticky-atc__title"></span>
        <span class="tn-sticky-atc__price"></span>
      </div>
      <button type="button" class="tn-sticky-atc__button">Add to cart</button>`;
    sticky.querySelector('.tn-sticky-atc__title').textContent = title;
    document.body.appendChild(sticky);

    sticky.querySelector('.tn-sticky-atc__button').addEventListener('click', () => {
      const main = root.querySelector('buy-buttons button[type="submit"]');
      if (main) main.click();
    });

    const target = root.querySelector('buy-buttons');
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(target);
  };

  const updateSticky = () => {
    if (!sticky || !state.price) return;
    const el = sticky.querySelector('.tn-sticky-atc__price');
    const html = `${fmt(state.price)}${state.compare ? ` <s>${fmt(state.compare)}</s>` : ''}`;
    if (el.innerHTML !== html) el.innerHTML = html;
  };

  const run = (root) => {
    if (writing) return;
    writing = true;
    try {
      updateBars(root);
      state = readSelection(root);
      updatePrice(root);
      buildSticky(root);
      updateSticky();
    } finally {
      writing = false;
    }
  };

  const init = () => {
    const root = document.querySelector('.shopify-section--main-product') || document.querySelector('product-info, .product-info');
    if (!root) return;
    let timer;
    const schedule = () => { clearTimeout(timer); timer = setTimeout(() => run(root), 60); };
    new MutationObserver(() => { if (!writing) schedule(); }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    run(root);
    setTimeout(() => run(root), 1500);
  };

  /* 4. Smooth scroll to reviews / buy box */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#tn-reviews"], a[href="#tn-buy"]');
    if (!link) return;
    const target = link.getAttribute('href') === '#tn-buy'
      ? document.querySelector('.shopify-section--main-product buy-buttons, buy-buttons')
      : document.getElementById('tn-reviews');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
